import { matchPath } from "react-router-dom";

export function getActive(path: string, pathname: string, children: Array<any> = []) {
  return path ? (!!matchPath({ path: path, end: false }, pathname) || children.some((child) => !!matchPath({ path: child, end: false }, pathname))) : false;
}
